import Deletable from "./Deletable";
import Expandable from "./Expandable";
import Favorite from "./Favorite";

export default { Deletable, Expandable, Favorite };



// WEBPACK FOOTER //
// ./ecology9/wea-tree-test/react-virtualized-tree/src/renderers/index.js